import React, { useState } from 'react'
import { Modal, Button, Input, message } from 'antd';
import "./offerPrint.css"
// import { useMaintenanceModel } from "../maintenanceModel"
//报价单打印
export interface IHeaderTitle {
    title: string,
    titleEn: string,
}
export interface IPrintClumns {
    title: string,
    dataIndex: string,
    render?: (text: string | number) => string
}
export interface ITitlePrint {
    quotation: string,
    quotationEnL: string
}
export interface IHeaderPrint {
    fieldLabel: string,
    fieldValue?: string | number,
    className?: string,
    border?: boolean,
}
export interface IFooterPrint {
    fieldLabel: string,
    fieldValue?: string | number,
    className?: string,
    border?: boolean,
}
interface Item {
    [key: string]: string | number | any
}
interface IPrintShow {
    header: IHeaderPrint[],
    footer: IFooterPrint[],
    footerPeople?: IFooterPrint[],
    note?: IFooterPrint,
    Total?: IFooterPrint[],
    Total1?: IFooterPrint[],
    // totalAmount: IPrintFieldInfo[],
    // itemAmount?: IPrintFieldInfo[]
}
export interface IPrintType {
    title?: string,
    type?: string,
    visible: boolean,
    onClose: () => void,
    onConfirm?: () => void,
    itemClumns?: IPrintClumns[], //维修项目字段及信息
    columns: IPrintClumns[],  //商品字段及信息
    dataSource: Item[],      //商品数据
    itemDataSource?: Item[],  //维修项目数据
    printShow: IPrintShow    //header 及 footer
    headerTitle: IHeaderTitle, //头部标题
}
export function YhOfferPrint({
    title = "",
    type = "",
    visible,
    onClose,
    onConfirm = () => null,
    columns,
    itemClumns,
    itemDataSource,
    dataSource,
    printShow,
    headerTitle
}: IPrintType) {
    // const {
    //     offerPrint: visible,
    //     setOfferPrint,
    // } = useMaintenanceModel();
    // const [offerPrint, setOfferPrint] = useState<boolean>(false)
    //遍历商品td
    const mapGoods = (goods: Item) => {
        return columns.filter(item => item).map((item, index) => <td key={index}>{item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}</td>)
    }
    //遍历项目td
    const itemGoods = (goods: Item) => {
        return itemClumns?.filter(item => item).map((item, index) => <td key={index}>{item.render ? item.render(goods[item.dataIndex]) : goods[item.dataIndex]}</td>)
    }
    const print = () => {
        const el: HTMLElement | null = document.getElementById('offerPrint-print-container');
        const iframe: any = document.createElement('IFRAME');
        let doc = null;
        document.body.appendChild(iframe);
        doc = iframe.contentWindow.document;
        // 引入打印的专有CSS样式，根据实际修改
        doc.write(`<LINK rel="stylesheet" type="text/css" href="./offerPrint1.css">`);
        doc.write(el?.innerHTML);
        doc.close();
        // 获取iframe的焦点，从iframe开始打印
        iframe.contentWindow.focus();
        iframe.onload = () => {
            iframe.contentWindow.print();
            document.body.removeChild(iframe);
        };
        if (navigator.userAgent.indexOf("MSIE") > 0) {
            document.body.removeChild(iframe);
        }
        onConfirm()
    }
    return <Modal
        title={title}
        width={1200}
        visible={visible}
        onCancel={onClose}
        footer={[
            <Button type="link" onClick={onClose} key="back"> 取消</Button>,
            <Button type="link" onClick={print} key="submit">确认打印</Button>,
            // <Button type="link" onClick={setTitle} key="setPrintName">设置</Button>
        ]}
    >
        {visible && <div id="offerPrint-print-container">
            <div className="offerPrint-container">
                <div className="title">
                    <h2>{headerTitle.titleEn}</h2>
                    <h2>{headerTitle.title}</h2>
                    {/* <h2>Asia-Africa International FZE</h2>
                    <h2>报价单</h2> */}
                </div>
                <ul className="header">
                    {printShow.header && printShow.header.map((item, index) => {
                        return <li className={item.className ?? ""} key={index}>{item.fieldLabel}{item.fieldValue}</li>
                    })}
                    {/* <li>报价单位：个体</li>
                <li>报价单号：BJ20210218005</li>
                <li>制单员：董英</li>
                <li>第1/1页</li>
                <li>合计金额：600000</li> */}
                </ul>
                <table className="mingxi">
                    <tbody>
                        <tr className="print-center" >
                            {columns && columns.filter(item => item).map((item, index) =>
                                <td key={index}>{item.title}</td>
                            )}
                        </tr>
                        {dataSource && dataSource.length > 0 &&
                            dataSource.map((item, index) =>
                                <tr key={index} className="print-center">
                                    {mapGoods(item)}
                                </tr>
                            )}
                        {itemDataSource && itemDataSource.length > 0 &&
                            itemDataSource.map((item, index) =>
                                <tr key={index} className="print-center">
                                    {itemGoods(item)}
                                </tr>
                            )}

                        {/* <tr className="print-center">
                        <td>序号 NO.</td>
                        <td>编号 Serial number</td>
                        <td>名称 name</td>
                        <td>规格 SPEC</td>
                        <td>产地 FORM</td>
                        <td>单位 unit</td>
                        <td>数量 amount</td>
                        <td>单价 unit price</td>
                        <td>金额 sum</td>
                        <td>备注 note</td>
                    </tr> */}
                        {/* <tr className="print-center">
                        <td>1</td>
                        <td>SJK00810</td>
                        <td>水泵</td>
                        <td>无</td>
                        <td>无</td>
                        <td>无</td>
                        <td>无</td>
                        <td>无</td>
                        <td>无</td>
                        <td>无</td>
                    </tr> */}
                    </tbody>
                </table>
                {printShow?.Total && <div className="print-total">
                    {printShow?.Total.map((item, index) => {
                        return <span key={index}>{item.fieldLabel}{item.fieldValue}</span>
                    })}
                    {/* <span>大写金额</span>
                    <span>其他金额</span>
                    <span>合计金额</span> */}
                </div>}
                {printShow?.Total1 && <div className="print-total">
                    {printShow?.Total1.map((item, index) => {
                        return <span key={index}>{item.fieldLabel}{item.fieldValue}</span>
                    })}
                </div>}                
                <div className="footer">
                    {printShow.footer && printShow.footer.map((item, index) => (
                        <p key={index}>{item.fieldLabel}{item.fieldValue}</p>
                    ))}
                    <ul className="footer-people">
                        {printShow.footerPeople?.map((item, index) => {
                            return <li key={index}>{item.fieldLabel}{item.fieldValue}</li>
                        })}
                        {/* <li>开单：</li>
                        <li>业务员：</li>
                        <li>财务：</li>
                        <li>仓库：</li>
                        <li>收货：</li> */}
                    </ul>

                    {printShow.note && <p>{printShow?.note?.fieldLabel}{printShow?.note?.fieldValue}</p>}
                </div>
            </div>
        </div>}
    </Modal>
}